import { createFileRoute } from "@tanstack/react-router";
import {
  runVerification,
  VerifyEmailView,
  type LoaderResult,
} from "./-verify-email-shared";

// Accept the token as a path segment so corporate email scanners
// (Outlook SafeLinks, Mimecast, Proofpoint) that strip or mangle query
// strings still deliver the token to us. Consumption logic is shared
// with the legacy /verify-email?token=... route via runVerification.
export const Route = createFileRoute("/verify-email_/$token")({
  loader: ({ params }): Promise<LoaderResult> => runVerification(params.token),
  head: () => ({
    meta: [
      { title: "Confirm your email: CapitalDart" },
      { name: "robots", content: "noindex,nofollow" },
      { name: "referrer", content: "no-referrer" },
    ],
  }),
  component: VerifyEmailTokenPage,
});

function VerifyEmailTokenPage() {
  const result = Route.useLoaderData() as LoaderResult;
  return <VerifyEmailView result={result} />;
}
